module.exports = __webpack_public_path__ + "static/media/flying-coach.95be4a9e.png";